var map = {
	"./Fienile01.jpg": 82265,
	"./Fienile02.webp": 86496,
	"./Fienile1.jpg": 8835,
	"./Fienile2.jpg": 62772,
	"./Fienile4.jpg": 38850,
	"./Fienile6.jpg": 16208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9053;